var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: {
      title: "料金マスタ準備",
      visible: _vm.dialogVisible,
      width: "45em"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("PreparationForm", {
              ref: "preparationForm",
              attrs: {
                action: "/preparation-fees-for-paid-passengers-master",
                tableType: "PAID_PASSENGERS"
              },
              model: {
                value: _vm.preparationFormModel,
                callback: function($$v) {
                  _vm.preparationFormModel = $$v
                },
                expression: "preparationFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("PreparationDialogFooter", {
              on: { preparation: _vm.clickPreparation }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }